import { render, staticRenderFns } from "./reisen-metadata-card-transfer.vue?vue&type=template&id=e0c3158e&scoped=true"
import script from "./reisen-metadata-card-transfer.vue?vue&type=script&lang=js"
export * from "./reisen-metadata-card-transfer.vue?vue&type=script&lang=js"
import style0 from "./reisen-metadata-card-transfer.vue?vue&type=style&index=0&id=e0c3158e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0c3158e",
  null
  
)

export default component.exports